import { AppRoute } from 'constants/AppRoute';

export function getCallingUrl(): string {
  return window.location.href
    .replace(AppRoute.UNAUTHORIZED, '')
    .replace(AppRoute.FORBIDDEN, '')
    .replace(AppRoute.ERROR, '');
}

export const allowedOrigins = new Set([
  'https://dev.impact.energyportal.ci.spglobal.com',
  'https://qa.impact.energyportal.ci.spglobal.com',
  'https://prod.impact.energyportal.ci.spglobal.com',
  'https://impact.energyportal.ci.spglobal.com',
  'https://qa.energyportal.ci.spglobal.com',
  'https://qa.energyportal.ci.spglobal.com',
  'https://qa.energyportal.ci.spglobal.com',
  'https://energyportal.ci.spglobal.com',
  'https://energyportal.ci.spglobal.com',
  'https://energyportal.ci.spglobal.com',
  'http://localhost:3000',
]);

const getOrigin = (url: string | undefined) => {
  if (!url) return null;

  try {
    return new URL(url).origin;
  } catch {
    return null;
  }
};

const getTrustedOrigins = (): string[] => [
  ...allowedOrigins,
  ...([
    window.location.origin,
    getOrigin(process.env.REACT_APP_IMMERSE_URL),
    getOrigin(process.env.REACT_APP_API_BASE_URL),
    getOrigin(process.env.REACT_APP_API_SP_URL),
  ].filter(Boolean) as string[]),
];

export function isAllowedOrigin(origin: string): boolean {
  return getTrustedOrigins().includes(origin);
}

const reencode = (value: string) => encodeURIComponent(decodeURIComponent(value));

/**
 * Returns a redirect URL rebuilt from a trusted origin and re-encoded path/query/hash,
 * or null when the URL is malformed, not http(s), or points to an untrusted origin.
 * The returned value never reuses the raw input, preventing open redirect / DOM XSS.
 */
export function getSafeRedirectUrl(url: string | null | undefined): string | null {
  if (!url) return null;

  try {
    const parsed = new URL(url);
    if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return null;

    const trustedOrigin = getTrustedOrigins().find((origin) => origin === parsed.origin);
    if (!trustedOrigin) return null;

    const path = parsed.pathname.split('/').map(reencode).join('/');
    const query = [...parsed.searchParams]
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
    const hash = parsed.hash.slice(1);

    return `${trustedOrigin}${path}${query ? `?${query}` : ''}${hash ? `#${reencode(hash)}` : ''}`;
  } catch {
    return null;
  }
}
